{
  "hero": {
    "eyebrow": "Come funziona",
    "title": "Monetizza oggi i flussi di cassa",
    "highlight": "futuri dei tuoi impianti",
    "subtitle": "Un processo guidato e trasparente: dall’analisi del tuo portafoglio di asset, all’attualizzazione dei flussi di cassa futuri."
  },
  "ctaTitle": "Pronto a moltiplicare la capacità del tuo portafoglio?",
  "schema": {
    "fotovoltaico": "Fotovoltaico",
    "eolico": "Eolico",
    "tariffaFissa": "tariffa fissa",
    "tariffaVar": "tariffa variabile",
    "context": {
      "goals": "obiettivi aziendali",
      "portfolio": "il tuo portafoglio",
      "tools": "strumenti di crescita"
    },
    "contractDone": "Contratto concluso",
    "counterpartyShare": "Quota controparte",
    "yourShare": "La tua quota",
    "revenuePlusGo": "Profitti + GO"
  },
  "modelCta": {
    "primary": "Scopri chi serviamo",
    "secondary": "Contattaci"
  },
  "dashboard": {
    "title": "Dashboard Produttore",
    "period": "Luglio 2026",
    "goRevenue": "Ricavo GO",
    "goRevenueUnit": "EUR questo mese",
    "goIssued": "GO emesse",
    "goIssuedUnit": "Garanzie di Origine",
    "activePlants": "Impianti attivi",
    "activePlantsUnit": "su 4 totali",
    "chartTitle": "Produzione e GO mensili",
    "production": "produzione",
    "issued": "emesse",
    "sold": "vendute",
    "yourPlants": "I tuoi impianti",
    "viewAll": "Vedi tutti"
  },
  "console": {
    "statusPending": "In qualifica"
  },
  "charts": {
    "cashflow": "CASH FLOW NETTO · 10 ANNI",
    "actualized": "ATTUALIZZATO A OGGI",
    "sharing": "CONDIVISIONE · PROFITTI + GO"
  },
  "model": {
    "steps": [
      {
        "k": "Step 01 · Il contesto",
        "t": "Raccontaci i tuoi obiettivi, il tuo portafoglio e gli strumenti utilizzati per espanderlo.",
        "d": "In una fase preliminare, DEC Energy si pone l’obiettivo di comprendere i target finanziari e di crescita del tuo portafoglio di asset rinnovabili, le route-to-market adottate e gli strumenti di finanziamento utilizzati."
      },
      {
        "k": "Step 02 · Identificazione dell’impianto",
        "t": "Elaboriamo la migliore offerta per i tuoi impianti e ti accompagniamo nella scelta delle condizioni contrattuali.",
        "d": "Con il fine di ottenere la cassa attualizzata da te desiderata, DEC Energy ti supporta nella selezione del miglior asset e nella definizione delle condizioni contrattuali da proporre alle nostre controparti."
      },
      {
        "k": "Step 03 · L’attualizzazione di cassa",
        "t": "Incassa immediatamente parte dei flussi di cassa futuri.",
        "d": "Selezioniamo insieme la controparte contrattuale e firmiamo l’accordo. Ricevi in unica soluzione l’attualizzazione di cassa."
      },
      {
        "k": "Step 04 · Durante il periodo contrattuale",
        "t": "Condividi profitti e Garanzie di Origine in base alle performance di produzione.",
        "d": "Per l’intera durata dell’accordo, continua a vendere elettricità, a pagare i tuoi costi finanziari e OPEX come facevi prima. A consuntivo, condividi con la controparte le Garanzie di Origine e una parte dei profitti generati."
      },
      {
        "k": "Step 05 · Al termine dell’accordo",
        "t": "Ritorna ad essere l’unico beneficiario della produzione.",
        "d": "Al termine del contratto, la controparte non ha più alcun diritto sul tuo impianto. Tutti i profitti e le Garanzie di Origine prodotti dall’impianto spettano a te in qualità di proprietario."
      }
    ]
  }
}
